<template>
    <div class="q-ma-none q-pa-none">
      <q-card class="my-card" flat>
        <q-card-section>
          <p class="text-h4 q-my-sm">Add your Business</p>
          <p class="text-subtitle2 text-primary">The new way of having loyal customers.</p>
        </q-card-section>
        <q-card-section class="q-ma-none q-pa-none">
            <div>
                <q-img src="/assets/bannerhero-merchant@2x.png" class="full-width">
                    <div class="absolute-full column justify-end white-opacity">
                        <p class="text-subtitle text-bold text-black q-pa-none">It takes less than 3 minutes</p>
                    </div>
                </q-img>
                <div class="row q-col-gutter-x-md q-col-gutter-y-md">
                    <div class="col-12">
                    <q-btn label="Add your business now" to="/merchant/addplace" size="md" unelevated color="primary"/>
                    </div>
                </div>
            </div>
        </q-card-section>
        <q-card-section>
            <div>
                <p class="text-h5 text-bold">Suitable to any business</p>
                <div class="row q-my-md">
                    <div class="col-2 q-mx-xs">
                        <q-icon color="primary" name="img:/assets/icons/girl-dig.svg" size="60px" />
                    </div>
                    <div class="col-2 q-mx-xs">
                        <q-icon color="primary" name="img:/assets/icons/bakery-dig.svg" size="60px" />
                    </div>
                    <div class="col-2 q-mx-xs">
                        <q-icon color="primary" name="img:/assets/icons/coffee-dig.svg" size="60px" />
                    </div>
                    <div class="col-2 q-mx-xs">
                        <q-icon color="primary" name="img:/assets/icons/icecream-dig.svg" size="60px" />
                    </div>
                    <div class="col-2 q-mx-xs">
                        <q-icon color="primary" name="img:/assets/icons/pizza-dig.svg" size="60px" />
                    </div>
                </div>
            </div>
            <q-list>
                <q-item v-ripple>
                    <q-item-section avatar>
                        <q-icon color="primary" name="img:/assets/icons/membercard-dig.svg" size="60px" />
                    </q-item-section>
                    <q-item-section>15% of customers postpone their visit when they forget their loyalty card.</q-item-section>
                </q-item>
            </q-list>

            <div class="row q-my-md justify-end">
                <div class="col-2 q-mx-xs">
                    <q-icon color="primary" name="img:/assets/icons/save-planet-dig.svg" size="60px" />
                </div>
            </div>
            <ul class="text-left text-caption2">
                <li>
                    No more paper cards. It's easier to engage your customers.
                </li>
                <li>
                    Easy to manage and give points
                </li>
                <li>
                    You choose how many points your customers need to win a perk
                </li>
                <li>
                    It's free for customers.
                </li>
                <li>
                    No app required. But you can add a shortcut to your device's home screen.
                </li>
                <li>
                    It's free for business up to 30 scans/month or A$20/month for 5000 scans and extra features.
                </li>
                <li>
                    No credit card needed on the free plan.
                </li>
            </ul>
        </q-card-section>
      </q-card>
    </div>
</template>